<template>
  <v-card @click.native.stop>
    <v-card-title>
      <v-row justify="end">
        <span class="headline custom-text">Assessment</span>
        <v-spacer></v-spacer>
        <v-btn color="#29284c" class="text-capitalize" outlined small @click="$emit('close')"
          >Not Now</v-btn
        >
        <v-btn
          color="#FF347C"
          small
          :loading="loading"
          depressed
          class="text-capitalize ml-2 white--text"
          @click="onQualify"
          >Check</v-btn
        >
      </v-row>
    </v-card-title>
    <v-card-text class="flex-nowrap">
      <v-row class="flex-nowrap px-4" justify="end" align="center">
        <v-avatar :size="70" class="shadow ml-5">
          <v-img :src="$store.getters.student.avatar"></v-img>
        </v-avatar>
        <v-spacer></v-spacer>
        <v-col cols="auto">
          <v-btn
            color="#29284c"
            fab
            x-small
            class="d-block white--text"
            depressed
            @click="increaseRating"
          >
            <v-icon>mdi-chevron-up</v-icon>
          </v-btn>
          <v-btn
            color="#29284c"
            fab
            x-small
            class="mt-2 white--text d-block"
            depressed
            @click="decreaseRating"
          >
            <v-icon>mdi-chevron-down</v-icon>
          </v-btn>
        </v-col>
        <span
          class="display-4 font-weight-semibold"
          style="color: #ff347c; letter-spacing: -0.3rem !important; width: 4rem"
          >{{ notes[rating - 1] }}</span
        >
        <!-- <span class="display-4 custom-text stick">/</span>
        <span class="display-1 custom-text mt-10 pt-2" style="margin-bottom: 7px">10</span>-->
      </v-row>
    </v-card-text>
  </v-card>
</template>
<script>
import { postQualification } from "@/api/api";

export default {
  props: {
    qualification: {
      required: true,
    },
  },
  data() {
    return {
      rating: 4,
      loading: false,
      notes: ["F", "E", "D", "C", "B", "A"],
    };
  },
  methods: {
    increaseRating() {
      if (this.rating < 6) {
        this.rating++;
      }
    },
    decreaseRating() {
      if (this.rating > 1) {
        this.rating--;
      }
    },
    async onQualify() {
      this.loading = true;
      let qual = this.qualification;
      qual.note = this.rating;
      const response = await postQualification(qual);
      if (response) {
        this.$emit("new-qual", response.data);
      }
      this.loading = false;
      this.$emit("close");
    },
  },
  computed: {
    small() {
      return this.$vuetify.breakpoint.xs;
    },
  },
};
</script>
